import { render, staticRenderFns } from "./HelpComponent.vue?vue&type=template&id=5e5475a7"
import script from "./HelpComponent.vue?vue&type=script&lang=js"
export * from "./HelpComponent.vue?vue&type=script&lang=js"
import style0 from "./HelpComponent.vue?vue&type=style&index=0&id=5e5475a7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports